/** Angular */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** Sixense */
import { BydModel } from '@sixense/byd-core-service';
/** Models */
import { BydUserRight } from '../models/byd-user-right';
/** Interfaces */
import { BydUserRightInterface } from '../interfaces/byd-user-right.interface';
import { BydUserRightsEnum } from '../enums/byd-user-rights.enum';

@Injectable({
  providedIn: 'root',
})
export class BydUserRightsService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService.
   */
  path: string;

  /**
   * Get the user rights.
   *
   * @param treeMode the tree mode
   * @param lang the language
   * @returns Observable<UserRight[]>
   */
  public getRights(treeMode: boolean, lang: string): Observable<BydModel<BydUserRight[]>> {
    this.path = treeMode ? '/userrights/tree' : '/userrights';
    if (lang) {
      this.path += `?lang=${lang}`;
    }
    return this.getModels<BydUserRight[]>();
  }

  /**
   * Returns all the rights of the user for a given project.
   *
   * @param projectId Chosen project id
   * @returns Observable<BydUserRightsEnum[]>
   */
  public getUserRights(projectId: number): Observable<BydUserRightsEnum[]> {
    this.path = `/v1/projects/${projectId}/currentuser/rights`;
    return this.get<BydUserRightsEnum[]>();
  }

  /**
   * Check rigtht on project by the given user id.
   *
   * @param projectId the prject id
   * @param userId the user id
   * @param right the right to check
   * @returns Observable
   */
  public checkRight(projectId: number, userId: number, right: number): Observable<boolean> {
    this.path = `/projects/${projectId}/users/${userId}/right/${right}`;
    return this.get();
  }

  /**
   * Implement inherited abstract member 'createNewInstance' from BydRhsAbstractService.
   *
   * @param userRight the user right
   * @returns BydUserRight
   */
  public createNewInstance(userRight: BydUserRightInterface): BydUserRight {
    return new BydUserRight(userRight);
  }
}
